// plugins/vue-devtools.client.js
export default defineNuxtPlugin(() => {
  if (import.meta.env.DEV) {
    const script = document.createElement('script');
    script.src = 'http://localhost:8098'; // or your LAN IP if using remote device
    script.async = true;
    document.head.appendChild(script);
  }
});
